export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13871.486425d3.jpg";